import { Component, OnInit, Input } from "@angular/core";
import { EnvironmentConfig } from "../../../core/models/environment-config.model";

declare var environment: EnvironmentConfig;

@Component({
  selector: "common-user-thumbnail",
  templateUrl: "./user-thumbnail.component.html",
  styles: [
    `
      .thumbnail {
        background-size: cover;
        height: 86px;
        width: 86px;
      }
      .icon-user {
        font-size: 3em;
      }
    `,
  ],
})
export class UserThumbnailComponent implements OnInit {
  @Input() imagePath: string;
  @Input() userName: string;

  @Input() imageUrl: string;

  constructor() {}

  ngOnInit(): void {
    if (!this.imageUrl) {
      this.imageUrl = this.imagePath && this.imagePath.length ? `url("${environment.baseImagePath}/${this.imagePath}")` : "";
    }
  }
}
